import { render, staticRenderFns } from "./AddImmediateNotification.vue?vue&type=template&id=09c20ee9&scoped=true&"
import script from "./AddImmediateNotification.vue?vue&type=script&lang=js&"
export * from "./AddImmediateNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c20ee9",
  null
  
)

export default component.exports